import GradingIcon from "@mui/icons-material/GradingRounded";
import TableChartIcon from "@mui/icons-material/TableChartRounded";
import { Box, Stack, Typography } from "@mui/material";
import { createFileRoute } from "@tanstack/react-router";
import Page from "@/components/Page";
import { LinkCard } from "@/components/Strategy/LinkCard";

function StrategiIndex() {
  return (
    <Page contentPadding maxWidth="xl">
      <Typography align="center" sx={{ my: 3 }} variant="h1">
        Strategisk data
      </Typography>
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={2}
          sx={{ maxWidth: 640, width: "100%" }}
        >
          <LinkCard
            Icon={TableChartIcon}
            label="Økonomisk sone"
            description="Inspeksjonsintervaller og vedlikeholdsstrategier for økonomisk sone."
            linkOptions={{ to: "/strategi/economic-zone" }}
          />
          <LinkCard
            Icon={GradingIcon}
            label="Vedlikeholdsnivåer"
            description="Vedlikeholdsstrategi per kontrollpunkt og sone."
            linkOptions={{ to: "/strategi/inspection-point" }}
          />
        </Stack>
      </Box>
    </Page>
  );
}

export const Route = createFileRoute("/_auth/strategi/")({
  component: StrategiIndex,
});
